import { ApiCreateSalesStock, ApiDeleteSalesStock, ApiGetSalesStockById, ApiGetSalesStockList, ApiUpdateSalesStock } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import { useModal } from 'context/ModalContext'
import { CheckResponse } from "utils/helpers";

export function SalesStockService() {
    const { showFail } = useModal()

    const { fetch: apiGetSalesStockList } = useFetch(ApiGetSalesStockList)
    const { fetch: apiDeleteSalesStock } = useFetch(ApiDeleteSalesStock)
    const { fetch: apiCreateSalesStock } = useFetch(ApiCreateSalesStock)
    const { fetch: apiGetSalesStockById } = useFetch(ApiGetSalesStockById)
    const { fetch: apiUpdateSalesStock } = useFetch(ApiUpdateSalesStock)

    const fetchSalesStockList = async(productName, brandId, stockCode, stockStatus, status, pageSize, index, groupBy) => {
        const res = await apiGetSalesStockList({
            data: {
                productName, 
                brandId,
                stockCode,
                stockStatus,
                status,
                pageSize,
                pageIndex: parseInt(index),
                groupBy
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteSalesStock = async(salesStockId, status) => {
        const res = await apiDeleteSalesStock({
            data: {
                salesStockId,
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCreateSalesStock = async(productId, stockIn, purchasePrice, sellingPrice, discount, quantity, size) => {
        const res = await apiCreateSalesStock({
            data: {
                productId,
                stockIn,
                purchasePrice,
                sellingPrice,
                discount,
                quantity,
                size
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateSalesStock = async(salesStockId, productId, stockIn, purchasePrice, sellingPrice, discount, size) => {
        const res = await apiUpdateSalesStock({
            data: {
                salesStockId,
                productId,
                stockIn,
                purchasePrice,
                sellingPrice,
                discount,
                size
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchSalesStockById = async(salesStockId) => {
        const res = await apiGetSalesStockById({
            data: {
                salesStockId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return { 
        fetchSalesStockList,
        fetchDeleteSalesStock,
        fetchCreateSalesStock,
        fetchUpdateSalesStock,
        fetchSalesStockById
    }
}